import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const ThirdPartyLogin = () => {
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get("token")
    const refreshToken = params.get("refreshToken")
    const platform = params.get("platform")

    if (token) {
      let decodedPayload = {}
      try {
        const payloadBase64 = token.split(".")[1]
        decodedPayload = JSON.parse(atob(payloadBase64))
      } catch (error) {
        console.error("Error decoding token:", error)
      }
      localStorage.setItem("userToken", token)
      if (refreshToken) {
        localStorage.setItem("refreshToken", refreshToken)
      }

      if (decodedPayload?.firstName) {
        localStorage.setItem(
          "userName",
          decodedPayload.firstName + " " + decodedPayload?.lastName
        )
      }
      if (platform) {
        localStorage.setItem("platform", platform)
      }

      if (token || refreshToken || platform) {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        )
      }
      navigate("/")
      window.location.reload()
    } else {
      console.error("No token found in URL parameters")
      navigate("/login")
    }
  }, [navigate])

  return <div>Loading...</div>
}

export default ThirdPartyLogin
